/**
 * Theme-wide Swiper defaults. Loaded with `defer` straight after the Swiper
 * library in layout/theme.liquid, so it runs before any carousel script
 * initialises a slider; a slider's own options still override these.
 *
 * Swiper's stock 300ms transition is short enough that the first slide, while
 * the newly revealed cards paint, loses most of its frames and reads as a jump
 * rather than a slide. 600ms keeps the movement visible on arrows, dots and
 * swipes alike.
 */
if (window.Swiper) {
  window.Swiper.extendDefaults({
    speed: 600,
  });
}
